<template>
  <page-layout
    title="发出的询价"
    class="p-OutgoingInquiry"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div
      class="p-OutgoingInquiry-header clearfix"
      v-if="datas.length > 0"
    >
      <div class="pull-left top-btnimg">
        <znl-button
          @mouseenter.native="bomsvg=bomListHover"
          @mouseleave.native="bomsvg=bomListNormal"
          :height="30"
          @click="visible=true"
        >
          <div class="btnimg"></div>
          智能询价
        </znl-button>
      </div>
      <div class="pull-right">
        <span class="adopted-model">
          已采纳型号
          <span class="colormain">
            {{InquireCount}}
          </span>
        </span>
        <znl-button
          :height="30"
          :disabled="InquireCount === 0"
          @click="exportStocks"
        >
          <i class="iconfont icon-leftnav_Inquiry-reco"></i>生成报价单
        </znl-button>
      </div>
    </div>

    <div class="p-OutgoingInquiry-body">
      <el-table
        v-for="(item, index) in datas"
        :key="index"
        :data="item.tradeBoms"
        :span-method="objectSpanMethod"
        :class="['p-OutgoingInquiry-grouping-module', index !== 0 ? 'hide-deader' : 'header-table']"
        :row-class-name="listRowClassName"
        :cell-class-name="cellClassName"
        @row-click="rowClickHandler"
      >
        <el-table-column
          prop="DemandModel"
          label="需求型号"
          class-name="column-DemandModel "
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.IsEditing">
              <span>
                <a
                  class="HoverA"
                  :href="`https://www.bom.ai/ic/${Base64Encode(scope.row.DemandModel)}.html`"
                  target="_blank"
                >{{scope.row.DemandModel}}</a>
              </span>
            </div>
            <div v-else>
              <znl-input
                width="100%"
                :border="true"
                :height="20"
                v-model="scope.row.TemporaryDemandModel"
              >
              </znl-input>
              <div :style="{height: '23px'}"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="DemandBrand"
          label="品牌"
          :width="120"
          class-name="column-DemandBrand "
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.IsEditing">
              <span>{{scope.row.DemandBrand}}</span>
            </div>
            <div v-else>
              <div>
                <znl-input
                  width="100%"
                  :border="true"
                  :height="20"
                  v-model="scope.row.TemporaryDemandBrand"
                >
                </znl-input>
              </div>
              <div :style="{height: '23px'}"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="DemandQty"
          label="需求量"
          :width="100"
          class-name="column-DemandQty border-right"
        >
          <template slot-scope="scope">

            <div
              class="p-OutgoingInquiry-qty"
              v-if="!scope.row.IsEditing"
            >
              <span>{{scope.row.DemandQty}}</span>
              <i
                class="iconfont icon-edit_ic"
                title="修改需求"
                @click="()=>{DataEdit(scope)}"
                v-if="scope.row.ID && scope.row.Stauts && (!scope.row.MatchSuppliers || scope.row.MatchSuppliers.length === 0)"
              ></i>
            </div>
            <div
              class="p-OutgoingInquiry-qty"
              v-else
            >
              <div>
                <znl-input
                  width="100%"
                  :border="true"
                  :height="20"
                  v-model="scope.row.TemporaryDemandQty"
                ></znl-input>
              </div>
              <div>
                <znl-button
                  type="text"
                  :height="20"
                  @click="()=>{DataSave(scope)}"
                >
                  保存
                </znl-button>
                <znl-button
                  type="text"
                  :height="20"
                  @click="()=>{cancelDataSave(scope)}"
                >
                  取消
                </znl-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="SupplierName"
          label="供应商"
          class-name="column-SupplierName color-cell-top"
        >
          <!-- row.MatchSuppliers -->
          <template slot-scope="scope">
            <div
              v-if="!scope.row.Stauts"
              class="no-Supplier"
            >
              正在匹配供应商，请稍后...
            </div>
            <div
              v-else-if="scope.row.MatchSuppliers && scope.row.MatchSuppliers.length > 0"
              class="Supplier-cell"
            >
              <span
                class="HoverCommon"
                @click.stop="()=>openChat(scope.row)"
              >
                {{scope.row.SupplierName}}
              </span>
              <span
                :class="['stype-cell', 'stype-z']"
                v-if="scope.row.Stype === 4 || scope.row.Stype === 8"
              >正</span>
              <span
                :class="['stype-cell', 'stype-b']"
                v-if="scope.row.Stype === 6"
              >现</span>

            </div>
            <div
              v-else
              class="no-Supplier"
              :class="[scope.row.RowClassName]"
            >
              无匹配型号或推荐型号，请检查型号名是否正确
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="SupplierModleBrand"
          label="型号/品牌"
          class-name="column-SupplierModleBrand"
        >
          <template slot-scope="scope">
            <div>
              <div
                class="color-cell-top"
                :class="[scope.row.SuppliersModel !== scope.row.DemandModel ? 'different-cell' : '']"
              >
                {{scope.row.SuppliersModel}}
              </div>
              <div
                class="color-cell-bottom"
                :class="[scope.row.DemandBrand && (scope.row.SuppliersBrand !== scope.row.DemandBrand) ? 'different-cell' : '']"
              >
                {{scope.row.SuppliersBrand}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Inventory"
          label="库存量"
          :width="100"
          class-name="column-Inventory"
        >
          <template slot-scope="scope">
            <div>
              <div
                class="color-cell-top"
                :class="[scope.row.SuppliersQty < scope.row.DemandQty ? 'different-cell' : '']"
              >{{scope.row.SuppliersQty}}</div>
              <div class="color-cell-bottom">{{scope.row.StockTimePhrase}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Price"
          label="参考价"
          :width="100"
          class-name="column-Price"
        >
          <template slot-scope="scope">
            <div>
              <div class="color-cell-top">
                <span
                  v-if="scope.row.YunPriceStr"
                  @mouseenter="(event)=>YunPriceListHandler(scope.row, true, event)"
                  @mouseleave="(event)=>YunPriceListHandler(scope.row,false, event)"
                >
                  {{scope.row.YunPriceStr}}
                  <!-- $100 -->
                </span>
                <span v-if="scope.row.Stauts && scope.row.MatchSuppliers && scope.row.MatchSuppliers.length > 0 && !scope.row.YunPriceStr">--</span>
              </div>
              <div class="color-cell-bottom">{{scope.row.YunPriceTimePhrase}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Offer"
          label="报价"
          :width="140"
          class-name="column-Offer"
        >
          <template slot="header">
            <span>报价</span>
          </template>
          <template slot-scope="scope">
            <div>
              <div class="color-cell-top">
                <el-popover
                  placement='bottom'
                  :width='280'
                  trigger='hover'
                  popper-class='c-ReceivedInquiry'
                  v-if="scope.row.QuoteCount > 1"
                >
                  <div
                    class="znl-Timeline-Trading clearfix"
                    v-for="(item, index) in scope.row.QuotationRecord"
                    :key="index"
                  >
                    <div class="pull-left znl-Timeline-com znl-Timeline-left">
                      {{item.CreatedTime}}
                    </div>
                    <div class="pull-left znl-Timeline-com znl-Timeline-center">
                      {{index === scope.row.QuotationRecord.length - 1 ? '供应商报价:' : '供应商重新报价:'}}
                    </div>
                    <div class="pull-left znl-Timeline-com znl-Timeline-right">
                      <span>￥</span>
                      <span>{{item.Price}}</span>
                    </div>
                  </div>

                  <i
                    class="iconfont icon-history_ic"
                    slot="reference"
                    @mouseenter="()=>{referenceMouseenter(scope.row)}"
                  ></i>
                </el-popover>
                <span class="span-Price">{{scope.row.PriceStr}}</span>
                <span
                  class="span-IsNeedInvoice"
                  v-if="scope.row.PriceStr"
                >{{scope.row.IsNeedInvoice ? '可开票' : ''}}</span>
                <span
                  class="color-cell-bottom"
                  v-if="scope.row.Stauts && scope.row.MatchSuppliers && scope.row.MatchSuppliers.length > 0 && !scope.row.PriceStr"
                >待报价</span>
              </div>
              <div class="color-cell-bottom">{{scope.row.ReplyTimePhrase}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Operation"
          label="操作"
          :width="100"
          class-name="column-Operation"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.Price">
              <znl-button
                style-type="main"
                :width="46"
                :height="22"
                @click="()=>adoptHandler(scope)"
                v-if="!scope.row.IsAdopt"
              >采纳</znl-button>
              <span
                v-else
                class="span-IsAdopt"
                @click="()=>adoptHandler(scope)"
              ><i class="iconfont icon-process_right_ic"></i></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        class="p-OutgoingInquiry-footer-pagination"
        v-if="datas.length > 0"
      >
        <el-pagination
          small
          layout="prev, pager, next"
          :total="TotalCount"
          :current-page.sync="PageIndex"
          @current-change="getDatas"
        >
        </el-pagination>
      </div>
    </div>

    <div
      class="p-OutgoingInquiry-empty"
      v-if="datas.length === 0 && !loading"
    >
      <div class="sendDefault"></div>
      <p>暂无数据，立即体验批量询价</p>
      <div class="footer">
        <znl-button
          @mouseenter.native="bomsvg=bomListHover"
          @mouseleave.native="bomsvg=bomListNormal"
          :height="30"
          @click="visible=true"
          class="bottom-btnimg"
        >
          <div class="btnimg"></div>
          添加批量询价
        </znl-button>
      </div>
    </div>

    <inquiry-iframe
      :visible.sync="visible"
      :get-datas="getDatas"
    ></inquiry-iframe>

    <yun-price
      :visible="showYunPriceList"
      :style="YunPriceStyle"
      ref="yunpricelist"
      :active-row="activeRow"
      :loading="yunPriceLoading"
      @mouseenter.native="()=>YunPriceListNativeHandler(true)"
      @mouseleave.native="()=>YunPriceListNativeHandler(false)"
    ></yun-price>
  </page-layout>
</template>
<script>
import InquiryIframe from '../InquiryIframe';
import bomListNormal from './imgs/bom-list_normal.svg';
import bomListHover from './imgs/bom-list_hover.svg';
import yunPrice from './YunPrice';
import {
  getOffsetSum,
  documentRect,
  getDomOfTag,
  addClass,
  removeClass
} from '../../assets/scripts/dom';
import { CONFIG } from '../../assets/scripts/config';
import { Base64Encode } from '../../assets/scripts/base64';
import { httpPost, httpGet } from '../../assets/scripts/http';
import TradingStore from '../../store';
import PageLayout from '../PageLayout';

export default {
  name: 'OutgoingInquiry',

  props: {
    companyClickHandler: Function
  },

  components: {
    InquiryIframe,
    yunPrice,
    PageLayout
  },

  data() {
    return {
      TradingStore,
      loadingText: '数据加载中,请稍后...',
      loading: false,
      visible: false,
      yunPriceLoading: false,
      bomListNormal,
      bomListHover,
      bomsvg: bomListNormal,
      bomListHover,
      datas: [],
      stopGetDatas: true,
      TimeID: null,
      PageIndex: 1,
      TotalCount: 1,
      InquireCount: 0,
      showYunPriceList: false,
      activeRow: { MyYunPriceList: null, MyYunPriceTotalCount: 0 },
      pageX: 0,
      pageY: 0,
      YunProceListHeight: 130,
      TimeID: null
    };
  },

  created() {
    this.stopGetDatas = false;
    this.getInquireCount();
    this.getDatas();
  },

  beforeDestroy() {
    this.stopGetDatas = true;
  },

  computed: {
    YunPriceStyle() {
      const style = {};
      style.left = this.pageX - 660 + 'px';
      if (documentRect().height / 2 > this.pageY) {
        style.top = this.pageY + 18 + 'px';
      } else {
        style.top = this.pageY - this.YunProceListHeight + 'px';
      }
      return style;
    }
  },

  methods: {
    rowClickHandler(row, event, column) {
      this.datas.forEach(item => {
        item.RowClassName = '';
        if (item && item.tradeBoms) {
          item.tradeBoms.forEach(data => {
            data.RowClassName = '';
          });
        }
      });
      this.$set(row, 'RowClassName', 'current-row');

      const ClassName = `.${row.DemandModel}${row.DemandBrand}`;
      if (ClassName) {
        const CELLELES = this.$el.querySelectorAll('.current-cell');
        if (CELLELES) {
          CELLELES.forEach(ele => {
            removeClass(ele, 'current-cell');
          });
        }
        const ELES = getDomOfTag(event.target, 'TBODY').querySelectorAll(
          ClassName
        );
        if (ELES) {
          ELES.forEach(ele => {
            addClass(ele, 'current-cell');
          });
        }
      }
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        return `${row.DemandModel}${row.DemandBrand}`;
      } else {
        return '';
      }
    },
    listRowClassName(rowObj) {
      return `${rowObj.row.RowClassName} ${rowObj.row.RowBorderClass}` || '';
    },
    Base64Encode(str) {
      if (!str) {
        return '';
      }
      return Base64Encode(str);
    },
    getInquireCount() {
      httpPost('tradeCentre/getInquireCount', { IsAccept: true }).then(res => {
        if (res.Code === 0) {
          this.InquireCount = res.Data || 0;
        }
      });
    },
    YunPriceListNativeHandler(type) {
      if (type) {
        clearTimeout(this.TimeID);
        this.showYunPriceList = true;
      } else {
        this.TimeID = setTimeout(() => {
          this.showYunPriceList = false;
          clearTimeout(this.TimeID);
        }, 300);
      }
    },
    YunPriceListHandler(row, type, event) {
      const TargetSize = getOffsetSum(event.target);

      this.pageX = TargetSize.left;
      this.pageY = TargetSize.top;
      if (type) {
        this.activeRow = row;
      }
      if (type) {
        clearTimeout(this.TimeID);
        this.showYunPriceList = true;
      } else {
        this.TimeID = setTimeout(() => {
          this.showYunPriceList = false;
          clearTimeout(this.TimeID);
        }, 300);
      }
      if (!row.MyYunPriceList) {
        this.yunPriceLoading = true;
        httpPost('tradeCentre/getPartQuoteList', {
          PartNo: row.SuppliersModel,
          PageIndex: 1,
          PageSize: 10
        })
          .then(res => {
            this.yunPriceLoading = false;
            if (res.Code === 0) {
              // 请求云价格数据
              this.activeRow.MyYunPriceList = res.Data.Data.ResultList;
              this.activeRow.MyYunPriceTotalCount = res.Data.Data.TotalCount;
            } else {
              this.activeRow.MyYunPriceList = [];
            }
            this.$nextTick(() => {
              this.YunProceListHeight = this.$refs.yunpricelist
                ? this.$refs.yunpricelist.$el.offsetHeight
                : 0;
            });
          })
          .catch(() => {
            this.yunPriceLoading = false;
          });
      } else {
        this.$nextTick(() => {
          this.YunProceListHeight = this.$refs.yunpricelist
            ? this.$refs.yunpricelist.$el.offsetHeight
            : 0;
        });
      }
    },
    ParseDataHandler(datas) {
      const DATAS = datas.map(item1 => {
        return {
          GroupId: item1.GroupId,
          IsNeedSend: item1.IsNeedSend,
          tradeBoms: item1.tradeBoms
            ? item1.tradeBoms.map(item2 => {
                return {
                  DemandModel: item2.Model,
                  DemandBrand: item2.Brand,
                  DemandQty: item2.Qty,
                  GroupId: item2.GroupId,
                  Stauts: item2.Stauts,
                  ID: item2.ID,
                  RowClassName: '',
                  MatchSuppliers:
                    item2.MatchSuppliers && item2.MatchSuppliers.length > 0
                      ? item2.MatchSuppliers.map((item3, j) => {
                          return {
                            SuppliersModel: item3.Model,
                            SuppliersBrand: item3.Brand,
                            SuppliersQty: item3.Qty,
                            IQGUID: item3.IQGUID,
                            Price: item3.Price,
                            PriceStr: item3.PriceStr,
                            SupplierID: item3.SupplierID,
                            SupplierName: item3.SupplierName,
                            YunPrice: item3.YunPrice,
                            YunPriceStr: item3.YunPriceStr,
                            BDLineGuid: item3.BDLineGuid,
                            ReplyTimePhrase: item3.ReplyTimePhrase,
                            StockTimePhrase: item3.StockTimePhrase,
                            YunPriceTimePhrase: item3.YunPriceTimePhrase,
                            IsAdopt: item3.IsAdopt,
                            IsNeedInvoice: item3.IsNeedInvoice,
                            QuoteCount: item3.QuoteCount,
                            Stype: item3.Stype,
                            MyYunPriceList: null,
                            MyYunPriceTotalCount: 0,
                            RowClassName: '',
                            RowBorderClass:
                              j < item2.MatchSuppliers.length - 1
                                ? 'RowBorderClass'
                                : ''
                          };
                        })
                      : []
                };
              })
            : []
        };
      });
      return DATAS;
    },

    ProcessTheData(datas) {
      // 按每个型号的供应商数量拆分
      const DATAS = [];
      // 自定义字段
      const CustomRow = {
        IsEditing: false,
        TemporaryModel: '',
        TemporaryBrand: '',
        TemporaryQty: ''
      };
      datas.forEach(item => {
        const RecommendedSuppliers = item.MatchSuppliers || [];
        if (RecommendedSuppliers.length > 0) {
          RecommendedSuppliers.forEach((data, j) => {
            // 只在每条拆分的第一条提供供应商列表，以便合并行，其他供应商列表均给空
            if (j === 0) {
              DATAS.push(Object.assign({}, item, data, CustomRow));
            } else {
              // 标记为合并行
              DATAS.push(
                Object.assign({}, item, data, CustomRow, {
                  NotParallel: true
                })
              );
            }
          });
        } else {
          // 标记为合并行
          DATAS.push(Object.assign({}, item, CustomRow, { NotParallel: true }));
        }
      });
      return DATAS;
    },
    exportStocks() {
      this.loading = true;
      this.loadingText = '生成中,请稍后...';
      httpGet('tradeCentre/tradeQuoteFile', null, { baseURL: 'up' })
        .then(res => {
          this.loading = false;
          this.loadingText = '数据加载中,请稍后...';
          if (res.Code === 0) {
            const filepath = `${CONFIG.RES_URL}tradeCentre/downloadQuote/${
              res.Data
            }`;
            const name = res.Data;
            const a = document.createElement('a');
            a.setAttribute('href', filepath);
            a.setAttribute('download', name);
            a.click();
            this.$succMess('导出成功');
            this.getDatas();
            this.getInquireCount();
          } else {
            this.$erroMess(res.Message);
          }
        })
        .catch(() => {
          this.loadingText = '数据加载中,请稍后...';
          this.loading = false;
        });
    },
    getDatas(PageIndex = 1) {
      clearTimeout(this.TimeID);
      this.loading = true;
      const vm = this;
      httpPost('tradeCentre/getBomInquirys', {
        PageIndex,
        PageSize: 10
      })
        .then(res => {
          this.loading = false;
          if (res.Code === 0) {
            const datas = this.ParseDataHandler(res.Data.ResultList);
            this.PageIndex = res.Data.PageIndex;
            this.TotalCount = res.Data.TotalCount;
            this.datas = datas.map(item => {
              return Object.assign({}, item, {
                tradeBoms: this.ProcessTheData(item.tradeBoms)
              });
            });
            this.datas.unshift({});
            // this.datas = [];

            // 检测到未完成的处理时每8秒重新请求
            let Stauts = true;
            for (const item of this.datas) {
              if (item.tradeBoms) {
                for (const bom of item.tradeBoms) {
                  if (!bom.Stauts) {
                    Stauts = false;
                    break;
                  }
                }
              }
              if (!Stauts) {
                break;
              }
            }
            if (!Stauts && !this.stopGetDatas) {
              this.TimeID = setTimeout(() => {
                vm.getDatas();
                clearTimeout(this.TimeID);
              }, 2000);
            }

            let IsNeedSend = false;
            const IsNeedSendArray = [];
            if (Stauts) {
              for (const item of this.datas) {
                if (item.IsNeedSend) {
                  IsNeedSend = true;
                  IsNeedSendArray.push(item.GroupId);
                }
              }
            }
            if (IsNeedSend) {
              // 插入聊天记录
              this.$ch('SendGroupEnquiry', IsNeedSendArray);
            }
          } else {
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        let rowspan = 1;
        if (row.MatchSuppliers) {
          // 有供应商时候，前三列必有合并行的操作，进行以下处理。否则都默认输出1
          if (row.NotParallel) {
            // 被标记为合并行的时候，有供应商的情况需要抵消前三列合并的行-输出0，没供应商时前三列没有合并行-正常输出1
            rowspan = row.MatchSuppliers.length > 0 ? 0 : 1;
          } else {
            // 没有被标记为合并行的时候，前三列已经进行了合并，需要合并的行数为等同于供应商数量的行数
            rowspan =
              row.MatchSuppliers.length > 0 ? row.MatchSuppliers.length : 1;
          }
        }
        return {
          rowspan,
          colspan: 1
        };
      } else if (columnIndex === 3) {
        // 没有供应商时合并3、4列
        if (row.MatchSuppliers.length === 0) {
          return {
            rowspan: 1,
            colspan: 2
          };
        }
      } else if (columnIndex === 4) {
        if (row.MatchSuppliers.length === 0) {
          return {
            rowspan: 1,
            colspan: 0
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    adoptHandler(scope) {
      httpPost(`tradeCentre/setAccepted`, [
        {
          IQGuid: scope.row.IQGUID,
          IsAccept: !scope.row.IsAdopt
        }
      ]).then(res => {
        if (res.Code === 0) {
          this.getDatas();
          this.getInquireCount();
        } else {
          this.$erroMess('操作失败');
        }
      });
    },
    ParseDataToNativeHandler(row) {
      // 转换未解析到供应商的数据
      return {
        Model: row.TemporaryDemandModel,
        Brand: row.TemporaryDemandBrand,
        Qty: row.TemporaryDemandQty,
        GroupId: row.GroupId,
        Stauts: row.Stauts,
        ID: row.ID,
        MatchSuppliers: []
      };
    },
    DataEdit(scope) {
      scope.row.TemporaryDemandModel = scope.row.DemandModel;
      scope.row.TemporaryDemandBrand = scope.row.DemandBrand;
      scope.row.TemporaryDemandQty = scope.row.DemandQty;
      scope.row.IsEditing = true;
    },
    DataSave(scope) {
      httpPost(
        'tradeCentre/updateTradeBom',
        this.ParseDataToNativeHandler(scope.row)
      ).then(res => {
        if (res && res.Code === 0 && res.Data) {
          this.getDatas();
        } else {
          this.$erroMess(res.Message);
        }
      });
    },
    cancelDataSave(scope) {
      scope.row.IsEditing = false;
    },
    openChat(row) {
      if (this.companyClickHandler) {
        this.companyClickHandler({
          CompanyName: row.SupplierName,
          CompanyID: row.SupplierID
        });
      }
    },
    referenceMouseenter(row) {
      httpPost('tradeCentre/searchQuotePriceHistory', {
        BDLineGuid: row.BDLineGuid,
        IQGuid: row.IQGUID,
        IsOrderbyCreatedTimeDesc: true,
        SearchType: 1
      }).then(res => {
        if (res.Code === 0) {
          this.$set(row, 'QuotationRecord', res.Data || []);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.p-OutgoingInquiry {
  .btnimg {
    width: 12px;
    height: 12px;
    display: inline-block;
    background-size: 100% 100%;
    position: relative;
    top: 2px;
  }
  .top-btnimg,
  .bottom-btnimg {
    .btnimg {
      background-image: url('./imgs/bom-list_normal.svg');
    }
    &:hover {
      .btnimg {
        background-image: url('./imgs/bom-list_hover.svg');
      }
    }
  }

  .p-OutgoingInquiry-header {
    line-height: 50px;
    .adopted-model {
      font-size: 14px;
      .colormain {
        color: #ee7700;
        font-weight: bold;
        padding: 0 10px 0 5px;
      }
    }
    .znl-button {
      img {
        position: relative;
        top: 2px;
      }
    }
  }
  .p-OutgoingInquiry-body {
    .p-OutgoingInquiry-qty {
      .iconfont {
        position: absolute;
        top: 50%;
        right: 3px;
        transform: translateY(-50%);
        color: #167cdb;
        cursor: pointer;
      }
    }
  }
  .p-OutgoingInquiry-grouping-module {
    margin-top: 10px;
    border-right: 1px solid #dbdbdb;
    border-left: 1px solid #dbdbdb;
    border-top: 1px solid #dbdbdb;
    &:hover {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    }
    .el-table__empty-block {
      display: none;
    }
    .column-Price {
      .color-cell-top {
        &:hover {
          text-decoration: underline;
        }
      }
    }
    th.column-Offer {
      .cell {
        span {
          margin-left: 10px;
        }
      }
    }
    td.column-Offer {
      .cell {
        padding-left: 20px;
        position: relative;
        .icon-history_ic {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .el-table__header-wrapper {
      th > .cell {
        background-color: #e6f0fa;
        color: $--fontcolor-dark-3;
        font-weight: bold;
        font-size: 12px;
        line-height: 28px;
      }
    }
    &.hide-deader {
      .el-table__header-wrapper {
        display: none;
      }
    }
    &.header-table {
      box-shadow: none;
    }
    td,
    th {
      border-right: none;
      &.is-leaf {
        border-right: none;
      }
    }
    td.border-right {
      border-right: 1px solid #f2f2f2;
    }
    td {
      border-bottom-color: #dbdbdb;
    }
    .current-cell {
      background-color: #fafafa !important;
    }
    .el-table__body tr.current-row > td {
      background-color: transparent;
      &.column-SupplierName,
      &.column-SupplierModleBrand,
      &.column-Inventory,
      &.column-Price,
      &.column-Offer,
      &.column-Operation {
        background-color: #eef4ff;
      }
    }
    .el-table__body tr.RowBorderClass > td {
      &.column-SupplierName,
      &.column-SupplierModleBrand,
      &.column-Inventory,
      &.column-Price,
      &.column-Offer,
      &.column-Operation {
        border-color: #f2f2f2;
      }
    }

    &.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: transparent;
      &.column-SupplierName,
      &.column-SupplierModleBrand,
      &.column-Inventory,
      &.column-Price,
      &.column-Offer,
      &.column-Operation {
        background-color: #eef4ff;
      }
    }
    td.cell {
      min-height: 50px;
    }
    td.column-Operation {
      .cell {
        min-height: 50px;
      }
      .znl-button,
      .span-IsAdopt {
        margin-top: 14px;
      }
      .span-IsAdopt {
        display: inline-block;
        width: 46px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #4caf50;
        box-sizing: border-box;
        border-radius: 4px;
        text-align: center;
        .iconfont {
          font-size: 30px;
          color: #4caf50;
        }
      }
    }
    td.column-DemandQty {
      position: relative;
    }
    td.column-SupplierName {
      .no-Supplier {
        color: rgba(0, 0, 0, 0.65);
      }
    }

    .color-cell-top {
      color: rgb(0, 0, 0);
      .span-Price {
        color: #ee7700;
        font-weight: bold;
      }
      .span-IsNeedInvoice {
        color: rgba(0, 0, 0, 0.25);
        padding-left: 10px;
      }
    }
    .color-cell-bottom {
      color: rgba(0, 0, 0, 0.45);
    }
    .Supplier-cell {
      .stype-cell {
        padding: 0 1px;
        color: #fff;
        font-size: 12px;
        border: 1px solid #ff2200;
        box-sizing: border-box;
      }
      .stype-z {
        background-color: #ff2200;
      }
      .stype-b {
        background-color: #fdf7a0;
        color: #ff2200;
      }
    }
    .different-cell {
      color: #ff2200;
    }
  }
  .p-OutgoingInquiry-empty {
    text-align: center;
    padding-top: 160px;
    p {
      color: #808080;
      line-height: 30px;
    }
    .footer {
      padding-top: 20px;
    }
    .sendDefault {
      width: 234px;
      height: 162px;
      background-image: url('./imgs/enquiry-send_default_pic.png');
      background-size: 100% 100%;
      margin: 0 auto;
    }
  }
  .p-OutgoingInquiry-footer-pagination {
    text-align: right;
    .el-pagination {
      background-color: #fff;
    }
    .el-pagination--small .btn-next,
    .el-pagination--small .btn-prev,
    .el-pagination--small .el-pager li,
    .el-pagination--small .el-pager li.btn-quicknext,
    .el-pagination--small .el-pager li.btn-quickprev,
    .el-pagination--small .el-pager li:last-child {
      border-color: transparent;
      font-size: 12px;
      line-height: 22px;
      height: 22px;
      min-width: 22px;
      font-weight: 100;
    }
    .el-pager li.active {
      color: #fff;
      background-color: #999;
    }
  }
  .icon-history_ic {
    color: #ee7700;
  }
}
</style>


